var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 29,
    viewBox: "0 0 75 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4569 0.948807C43.3133 0.948807 40.7649 3.49719 40.7649 6.64077V28.5082H44.1132V6.64077C44.1132 5.34636 45.1625 4.29702 46.4569 4.29702H51.301V0.948807H46.4569Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6518 0.844543V3.962H75V0.844543H71.6518Z",
    fill: "#FF5468"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6518 7.31025V28.5081H75V7.31025H71.6518Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7178 13.6532H46.4253V28.5082H49.7735V13.6532H51.301V10.305H44.7178V13.6532Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6626 12.9147V14.983H28.7663V18.3312H32.6626V23.6007C32.6626 24.5253 31.9131 25.2748 30.9885 25.2748H30.2855V28.623H30.9885C33.7622 28.623 36.0108 26.3744 36.0108 23.6007V18.3312H39.6539V14.983H36.0108V12.9147H32.6626Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.105 19.464V23.8302H31.4532V19.464H28.105Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7138 19.464V23.8302H40.062V19.464H36.7138Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2462 1.06348V1.88434H28.7663V5.23256H39.4007V1.88434H35.5944V1.06348H32.2462Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2518 7.73235L30.4376 7.96118C30.7994 8.40679 31.2184 8.77219 31.6742 9.05738H28.0067V12.4056H40.1603V9.05738H36.9992C37.455 8.77219 37.874 8.40679 38.2358 7.96118L38.4216 7.73235L35.8222 5.62198L35.6364 5.85081C34.9664 6.67604 33.707 6.67604 33.037 5.85081L32.8512 5.62198L30.2518 7.73235Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2813 0.948644H59.9331L54.2411 28.1763H57.5511L59.1923 20.6214H62.9465L62.2768 17.2732H59.9196L61.7393 8.89657L66.6816 28.2354L69.9777 28.1763L63.2813 0.948644Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4195 1.21468V27.9073H17.6756C21.9287 27.9073 25.3765 24.4595 25.3765 20.2064V1.21468H13.4195ZM16.7677 24.5591V4.56289H22.0283V20.2064C22.0283 22.6104 20.0795 24.5591 17.6756 24.5591H16.7677Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.37533V7.10376H11.5488V3.75555H3.34822V1.37533H0Z",
    fill: "#FF5468"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4879H4.22275V10.6585H7.57096V12.4879H11.5488V15.8362H0V12.4879Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33079 17.0707L0.18687 27.024L3.16135 28.5612L6.80608 21.5087L10.318 23.2136L11.7802 20.2016L5.33079 17.0707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLogo);
export default __webpack_public_path__ + "static/media/activeLogo.5554b1c1ed17d13de27389705d095ed8.svg";
export { ForwardRef as ReactComponent };